import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { login } from "../../../api/endpoints/AuthEndpoints";
import { LoginResponse } from "../../../models/LoginResponse";

export default function useLogin() {
  return useMutation<
    LoginResponse,
    AxiosError,
    { credentials: { email: string; password: string } }
  >({
    mutationKey: ["login"],
    mutationFn: ({ credentials }) => login(credentials),
  });
}
